import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { RecycleScroller } from 'vue-virtual-scroller'
import dayjs from 'dayjs';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
const app = createApp(App)
    .use(store)
    .use(router)
    .component('recycle-scroller', RecycleScroller)
    .mixin({
        data() {
            return {dayjs}
        },
        methods: {
            titleCase(words) {
                return words.split(' ').map((word) => { 
                    return word[0].toUpperCase() + word.substring(1); 
                }).join(" ");
            },

            playerName(player_id) {
                return this.$store.state.players[player_id].name;
            },

            getplayer(player_id) {
                if (!player_id) return {
                    name: 'Anonymous',
                    id: 0
                }
                return this.$store.state.players[player_id];
            },
            toCurrency(value) {
                return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },

        computed: {
            current_screen() {
                return this.$store.state.navigation.screen;
            }
        }
        
    })
    .mount('#app');


